export default {
    CAN: [
        { name: 'America/Atikokan', offset: '-05:00' },
        { name: 'America/Blanc-Sablon', offset: '-04:00' },
        { name: 'America/Cambridge_Bay', offset: '-07:00' },
        { name: 'America/Creston', offset: '-07:00' },
        { name: 'America/Dawson', offset: '-07:00' },
        { name: 'America/Dawson_Creek', offset: '-07:00' },
        { name: 'America/Edmonton', offset: '-07:00' },
        { name: 'America/Fort_Nelson', offset: '-07:00' },
        { name: 'America/Glace_Bay', offset: '-04:00' },
        { name: 'America/Goose_Bay', offset: '-04:00' },
        { name: 'America/Halifax', offset: '-04:00' },
        { name: 'America/Inuvik', offset: '-07:00' },
        { name: 'America/Iqaluit', offset: '-05:00' },
        { name: 'America/Moncton', offset: '-04:00' },
        { name: 'America/Nipigon', offset: '-05:00' },
        { name: 'America/Pangnirtung', offset: '-05:00' },
        { name: 'America/Rainy_River', offset: '-06:00' },
        { name: 'America/Rankin_Inlet', offset: '-06:00' },
        { name: 'America/Regina', offset: '-06:00' },
        { name: 'America/Resolute', offset: '-06:00' },
        { name: 'America/St_Johns', offset: '-03:30' },
        { name: 'America/Swift_Current', offset: '-06:00' },
        { name: 'America/Thunder_Bay', offset: '-05:00' },
        { name: 'America/Toronto', offset: '-05:00' },
        { name: 'America/Vancouver', offset: '-08:00' },
        { name: 'America/Whitehorse', offset: '-07:00' },
        { name: 'America/Winnipeg', offset: '-06:00' },
        { name: 'America/Yellowknife', offset: '-07:00' },
    ],
    USA: [
        { name: 'America/Adak', offset: '-10:00' },
        { name: 'America/Anchorage', offset: '-09:00' },
        { name: 'America/Boise', offset: '-07:00' },
        { name: 'America/Chicago', offset: '-06:00' },
        { name: 'America/Denver', offset: '-07:00' },
        { name: 'America/Detroit', offset: '-05:00' },
        { name: 'America/Indiana/Indianapolis', offset: '-05:00' },
        { name: 'America/Indiana/Knox', offset: '-06:00' },
        { name: 'America/Indiana/Marengo', offset: '-05:00' },
        { name: 'America/Indiana/Petersburg', offset: '-05:00' },
        { name: 'America/Indiana/Tell_City', offset: '-06:00' },
        { name: 'America/Indiana/Vevay', offset: '-05:00' },
        { name: 'America/Indiana/Vincennes', offset: '-05:00' },
        { name: 'America/Indiana/Winamac', offset: '-05:00' },
        { name: 'America/Juneau', offset: '-09:00' },
        { name: 'America/Kentucky/Louisville', offset: '-05:00' },
        { name: 'America/Kentucky/Monticello', offset: '-05:00' },
        { name: 'America/Los_Angeles', offset: '-08:00' },
        { name: 'America/Menominee', offset: '-06:00' },
        { name: 'America/Metlakatla', offset: '-09:00' },
        { name: 'America/New_York', offset: '-05:00' },
        { name: 'America/Nome', offset: '-09:00' },
        { name: 'America/North_Dakota/Beulah', offset: '-06:00' },
        { name: 'America/North_Dakota/Center', offset: '-06:00' },
        { name: 'America/North_Dakota/New_Salem', offset: '-06:00' },
        { name: 'America/Phoenix', offset: '-07:00' },
        { name: 'America/Port_of_Spain', offset: '-04:00' },
        { name: 'America/Puerto_Rico', offset: '-04:00' },
        { name: 'America/Sitka', offset: '-09:00' },
        { name: 'America/Yakutat', offset: '-09:00' },
        { name: 'Pacific/Guam', offset: '+10:00' },
        { name: 'Pacific/Honolulu', offset: '-10:00' },
        { name: 'Pacific/Pago_Pago', offset: '-11:00' },
    ]
};